export default "__VITE_ASSET__DbY3SsAX__"